<bb-page-header [icon]="'paper-plane'" [title]="projectTitle" [backOnMobile]="['/analytics/projects']">
	<div class="project-goal bb-header-extra" *ngIf="project && project.goal">
		{{ project.goal }}
	</div>
	<ul class="tabs" *ngIf="project">
		<li>
			<a [routerLink]="['/analytics/project', projectId, 'performance']" routerLinkActive="" [class.active]="activeTab === 'performance'"><!-- hack to fix routerLinkActive after create new -->
				<i class="fa fa-bar-chart"></i> {{ 'PERFORMANCE' | translate }}
			</a>
		</li>
		<li>
			<a [routerLink]="['/analytics/project', projectId, 'flow-analysis']" routerLinkActive="active">
				<i class="fa fa-sitemap rotate-270"></i> {{ 'FLOW_ANALYSIS' | translate }}
			</a>
		</li>
	</ul>
</bb-page-header>

<div class="body-column tab-container" [class.flow-analysis-overlay]="activeTab === 'flow-analysis'">
	<!-- Filter header -->
	<div class="button-wrapper">		
		<mat-form-field appearance="fill" *ngIf="projectContextOptions?.length" class="context-filter">
			<mat-label>{{'CONTEXT_FILTER' | translate}}</mat-label>
			<bb-entity-selector
				[inMatFormField]="true"
				[disableClear]="true"
				name="context"
				theme="light-v2"
				placeholder=""
				[options]="projectContextOptions"
				[(ngModel)]="projectService.projectContextWithNone"
				(ngModelChange)="onContextChange()"
			></bb-entity-selector>
		</mat-form-field>
		<bb-date-presets
			*ngIf="!noFlowchart && minDate"
			theme="analytics"
			[useMatFormField]="true"
			(onChanged)="datesChanged($event)"
			[preset]="'last-6-months'"
			[icon]="'line-chart'"
			[minDate]="minDate"
			[minDateWarning]="'HELP.PROJECT_STATS_DATE_CORRECTED' | translate: {date: (minDate | date)}"
		></bb-date-presets>

		<div class="download-menu">
			<button mat-icon-button [matMenuTriggerFor]="includeMenu">
				<i class="far fa-ellipsis-vertical fa-lg"></i>
			 </button>
		</div>
		<mat-menu #includeMenu="matMenu">
			<span mat-menu-item disabled class="menu-subheader">
				{{ 'DOWNLOADS' | translate }}
			</span>
			<a *ngIf="projectStatsQueryParamsString" mat-menu-item class="download feedback black-link" download href="{{ projectDownloadUrl }}/formdata?{{ projectStatsQueryParamsString }}">
				<i class="fa fa-comments-o"></i>
				{{ 'FORM_DATA' | translate }}
			</a>

			<a *ngIf="projectStatsQueryParamsString" mat-menu-item class="download statistics black-link" download href="{{ projectDownloadUrl }}/sheet?{{ projectStatsQueryParamsString }}">
				<i class="fa fa-line-chart"></i>
				{{ 'STATISTICS' | translate }}
			</a>

			<a mat-menu-item class="download feedback black-link" (click)="downloadPerformance()">
				<i class="fa fa-gauge"></i>
				{{ 'PERFORMANCE' | translate }}
			</a>
			<mat-divider [hasPermission]="'projects'"></mat-divider>
			<a [hasPermission]="'projects'" mat-menu-item class="blue-link" [routerLink]="['/library/project/', project?.id]">
				<i class="fa fa-line-chart"></i>
				<span class="short-label">
					{{ 'OPEN_PROJECT' | translate }}
				</span>
			</a>
		</mat-menu>
	</div>

	<!-- Performance -->
	<project-stats-performance
		*ngIf="project && project.id === projectId && tabLoadedBefore('performance')"
		[hidden]="activeTab !== 'performance'"
		class="performance-tab"
		[configuration]="configuration"
		[project]="project"
	></project-stats-performance>

	<!-- Flow analysis -->
	<div class="flow-analysis-tab" *ngIf="activeTab === 'flow-analysis'">
		<div class="no-project-steps" *ngIf="noFlowchart">{{ 'PROJECT_WITHOUT_MEDIACLIPS' | translate }}.</div>

		<div *ngIf="project && project.id === projectId && !noFlowchart && clipCount === 1" class="project-stats-canvas">
			<stats-progress class="contents"
				[parentEntityType]="'Project'"
				[parentEntityId]="projectId"
				[clipId]="firstStep.entityId"
				[configuration]="configuration"
				style="height: 100%; width: 100%;">
			</stats-progress>
		</div>

		<div class="project-flowchart" *ngIf="project && project.id === projectId && clipCount > 1">
			<flowchart-editor *ngIf="flowchart" [flowchart]="flowchart" [haveProjectStepsStats]="!!project?.chapters" [statsMode]="true" [disableDragging]="true"></flowchart-editor>
		</div>
	</div>
</div>
